import React from 'react';
import { BaseDialog } from './BaseDialog.js';

export function DrazticVideoDialog(data) {
    return (
        <BaseDialog thumbnail={data.thumbnail} title={data.title} text={data.text}>
            <video style={{ width: '100%', maxWidth: 540, height: 'auto' }} controls>
                <source src={data.mp4} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </BaseDialog>
    );
}
